import { Help } from 'ui/icons/action/Help';
import { Tooltip } from './Tooltip';
import { Toggletip } from './Toggletip';
import { FocusStyle, HelpTooltipProps } from './types';

export const HelpTooltip = ({ tooltipContent, iconProps = {}, ...props }: HelpTooltipProps) => {
  return (
    <Tooltip $focusStyle={FocusStyle.Round} tooltipContent={tooltipContent} {...props}>
      <Help {...iconProps} />
    </Tooltip>
  );
};

export const HelpToggletip = ({ tooltipContent, iconProps = {}, ...props }: HelpTooltipProps) => {
  return (
    <Toggletip $focusStyle={FocusStyle.Round} tooltipContent={tooltipContent} {...props}>
      <Help {...iconProps} />
    </Toggletip>
  );
};
